import NotificationMixin from "app/layout/LayoutNotificationViewModelMixin";
export default kendo.data.ObservableObject.extend(NotificationMixin).extend({
    onInit: function() {
        this.initNotification();
    }
});